module.exports = __webpack_public_path__ + "static/media/23_plantilla_combo_cuadrada_marco_comida_41.2ba21ab9.png";